// extracted by mini-css-extract-plugin
export default {"maintenance-template":"styles_maintenance-template__YHj17","explanation-text":"styles_explanation-text__Z4kLH"};